"use client";

import { useEffect, useState } from "react";
import { authService } from "@/services/auth";
import { useAuthStore } from "@/stores/auth";

type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export function useAuth() {
  const [status, setStatus] = useState<AuthStatus>("loading");
  const xperisusUser = useAuthStore((s) => s.xperisusUser);

  useEffect(() => {
    const checkAuth = async () => {
      const isAuthenticated = await authService.isAuthenticated();
      if (isAuthenticated && !xperisusUser) {
        await authService.loadXperisusUser();
      }
      setStatus(isAuthenticated ? "authenticated" : "unauthenticated");
    };

    checkAuth();
  }, [xperisusUser]);

  return {
    status,
    xperisusUser,
    isLoading: status === "loading",
    isAuthenticated: status === "authenticated",
    isUnauthenticated: status === "unauthenticated",
  };
}
